export const url = {
    routes : {
        signupSpecialist : "user/register",
        verifyEmail : "user/verifyEmail"

    }
}